// extracted by mini-css-extract-plugin
module.exports = {"rowRemoved":"BuildingAdditionalAddressesModal_rowRemoved_2HKcX","rowNew":"BuildingAdditionalAddressesModal_rowNew_3pI4O"};